// extracted by mini-css-extract-plugin
export var menu = "header-module--menu--3pgt5";
export var nav = "header-module--nav--27uXx";
export var scrolled = "header-module--scrolled--2qvv3";
export var menuOpened = "header-module--menuOpened--1jVI_";